module.exports = __webpack_public_path__ + "img/alert.761d5cd9.svg";